/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$( document ).ready(function() {
    $('.collection_information_block-text div').each(function(  ) {
    this.removeAttribute('style');
    });
    setTimeout(function (){
        $('.slick-arrow').on('click',function (){
            $('.slick-dots').animate({
                scrollTop: $('.slick-dots').find($('.slick-active')).position().left
            }, 500);
        })
    },500)
    $('.scroll_top-btn').on('click',function (){
        $([document.documentElement, document.body]).animate({
            scrollTop: 0
        }, 2000);
    })
    $('.open_cookie').on('click',function(){
    	$('.cc-settings-view').show();
    });
   
});
